export default __webpack_public_path__ + "static/media/smyPhoto2.49164680.jpg";